export const activity = {
  activityWebEmptyStateTitle: 'Nessuna attività ancora',
  activityWebEmptyStateText: 'Qui sarà il tuo feed di notifiche',
  activitySeeAll: 'Vedi tutto',
  in: 'in'
}
